import { AvField, AvForm } from "availity-reactstrap-validation";
import { Button, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../Enums/Tranlate";
import { useEffect, useState } from "react";
import BaseService from "../../../services/BaseService";
import HomeHeaderService from "../../../services/HomeHeaderService";
import { toast } from "react-toastify";
import HomeProjectsService from "../../../services/HomeProjectsService";
import HomeClientsService from "../../../services/HomeClientsService";
import HomeVideoService from "../../../services/HomeVideoService";
import Select from "react-select";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

const Home = () => {
	const [formData, setFormData] = useState({
		title_en: EditorState.createEmpty(),
		title_ar: EditorState.createEmpty(),
		description_en: EditorState.createEmpty(),
		description_ar: EditorState.createEmpty(),
		link: "",
		id: "",
	});
	const [errors, setErrors] = useState({
		title_en: false,
		title_ar: false,
		description_en: false,
		description_ar: false,
	});
	const lang = useSelector((state) => state.auth.lang);
	const LinksOptions = [
		{ label: Translate[lang].projects, value: "projects" },
		{ label: Translate[lang].media, value: "media-center" },
		{ label: Translate[lang].about, value: "about-us" },
		{ label: Translate[lang].contact_us, value: "contact-us" },
	];
	const [clientsData, setClientsData] = useState([]);
	const [videoData, setVideoData] = useState({
		loading: false,
		video: "",
	});
	const [projectData, setProjectData] = useState({
		projects: "",
		employees: "",
		countries: "",
		continents: "",
		images: [],
		loading: false,
	});

	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [shouldClientUpdate, setShouldClientUpdate] = useState(false);
	const [shouldVideoUpdate, setShouldVideoUpdate] = useState(false);
	const [submitHeaderLoader, setSubmitHeaderLoader] = useState(false);
	const [submitProjectsLoader, setSubmitProjectsLoader] = useState(false);
	const [loadingClients, setLoadingClients] = useState(false);
	const [newClients, setNewClients] = useState([]);
	const homeHeaderService = new HomeHeaderService();
	const homeProjectsService = new HomeProjectsService();
	const homeClientsService = new HomeClientsService();
	const homeVideoService = new HomeVideoService();

	useEffect(() => {
		homeHeaderService.getList().then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data?.data;
				if (!!response?.length) {
					setFormData({
						title_en: EditorState.createWithContent(
							ContentState.createFromBlockArray(
								htmlToDraft(response[0].title_en)
							)
						),
						title_ar: EditorState.createWithContent(
							ContentState.createFromBlockArray(
								htmlToDraft(response[0].title_ar)
							)
						),
						description_en: EditorState.createWithContent(
							ContentState.createFromBlockArray(
								htmlToDraft(response[0].description_en)
							)
						),
						description_ar: EditorState.createWithContent(
							ContentState.createFromBlockArray(
								htmlToDraft(response[0].description_ar)
							)
						),
						link: LinksOptions.find((link) => link?.value === response[0].link),
						id: response[0].id,
					});
				}
			}
		});
	}, [shouldUpdate]);

	useEffect(() => {
		homeClientsService.getList().then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data;
				if (!!response?.length) {
					let dataInfo = response?.map((info) => ({
						id: info?.id,
						image: info?.image,
					}));
					setClientsData(dataInfo);
				}
			}
		});
	}, [shouldClientUpdate]);

	useEffect(() => {
		homeProjectsService.getList().then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data;
				setProjectData({
					projects: response.projects,
					employees: response.employees,
					countries: response.countries,
					continents: response.continents,
					images: response.home_project_images?.map((imgSrc) => imgSrc?.url),
				});
			}
		});
	}, []);

	useEffect(() => {
		homeVideoService.getList().then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data;
				if (!!response) {
					setVideoData({
						video: response.video,
						loading: false,
						uploaded: true,
					});
				}
			}
		});
	}, [shouldVideoUpdate]);

	const fileHandler = (e, name) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (name === "projects") {
			if (projectData?.images?.length === 4) {
				return;
			}
			if (projectData?.images?.length + filesData?.length > 4) {
				toast.error("Max 4 images");
				return;
			}
			setProjectData((prev) => ({ ...prev, loading: true }));
		}
		if (name === "video") {
			setVideoData((prev) => ({ ...prev, loading: true }));
		}
		if (name === "clients") {
			setLoadingClients(true);
		}

		if (!!filesData?.length) {
			Promise.all(
				filesData?.map((response) => new BaseService().postUpload(response))
			).then((response) => {
				if (name === "projects") {
					setProjectData((prev) => ({
						...prev,
						images: [...prev?.images, ...response.map((img) => img?.data.url)],
						loading: false,
					}));
				}
				if (name === "clients") {
					setLoadingClients(false);
					setNewClients((prev) => [
						...prev,
						...response.map((img) => ({ image: img?.data.url })),
					]);
				}
				if (name === "video") {
					setVideoData({
						video: response[0]?.data.url,
						loading: false,
						uploaded: false,
					});
				}
			});
		}
	};

	const submitHeader = () => {
		if (!formData?.link) {
			toast.error("Select Link");
			return;
		}
		if (
			!draftToHtml(
				convertToRaw(formData?.title_en.getCurrentContent())
			)?.replace("<p></p>\n", "") ||
			!draftToHtml(
				convertToRaw(formData?.title_ar.getCurrentContent())
			)?.replace("<p></p>\n", "") ||
			!draftToHtml(
				convertToRaw(formData?.description_en.getCurrentContent())
			)?.replace("<p></p>\n", "") ||
			!draftToHtml(
				convertToRaw(formData?.description_ar.getCurrentContent())
			)?.replace("<p></p>\n", "")
		) {
			setErrors({
				title_en: !draftToHtml(
					convertToRaw(formData?.title_en.getCurrentContent())
				)?.replace("<p></p>\n", ""),
				title_ar: !draftToHtml(
					convertToRaw(formData?.title_ar.getCurrentContent())
				)?.replace("<p></p>\n", ""),
				description_en: !draftToHtml(
					convertToRaw(formData?.description_en.getCurrentContent())
				)?.replace("<p></p>\n", ""),
				description_ar: !draftToHtml(
					convertToRaw(formData?.description_ar.getCurrentContent())
				)?.replace("<p></p>\n", ""),
			});
			return;
		}
		let data = {
			title_en: draftToHtml(
				convertToRaw(formData?.title_en.getCurrentContent())
			),
			title_ar: draftToHtml(
				convertToRaw(formData?.title_ar.getCurrentContent())
			),
			description_en: draftToHtml(
				convertToRaw(formData?.description_en.getCurrentContent())
			),
			description_ar: draftToHtml(
				convertToRaw(formData?.description_ar.getCurrentContent())
			),
			link: formData?.link?.value,
		};
		setSubmitHeaderLoader(true);
		if (!!formData?.id) {
			homeHeaderService.update(formData?.id, data).then((res) => {
				if (res?.status === 200) {
					toast.success(`${Translate[lang].updated_successfully}`);
					setShouldUpdate((prev) => !prev);
				}
				setSubmitHeaderLoader(false);
			});
		} else {
			homeHeaderService.create(data).then((res) => {
				if (res?.status === 201) {
					toast.success(`${Translate[lang].added_successfully}`);
				}
				setSubmitHeaderLoader(false);
			});
		}
	};
	const submitProjects = () => {
		let data = {
			projects: Number(projectData?.projects),
			employees: Number(projectData?.employees),
			countries: Number(projectData?.countries),
			continents: Number(projectData?.continents),
			images: projectData?.images,
		};
		setSubmitProjectsLoader(true);
		homeProjectsService.create(data).then((res) => {
			if (res?.status === 201) {
				toast.success(`${Translate[lang].updated_successfully}`);
			}
			setSubmitProjectsLoader(false);
		});
	};

	const submitClients = () => {
		let data = {
			images: newClients?.map((res) => res?.image),
		};
		setLoadingClients(true);
		homeClientsService.create(data).then((res) => {
			if (res?.status === 201) {
				toast.success(`${Translate[lang].updated_successfully}`);
				setNewClients([]);
				setShouldClientUpdate((prev) => !prev);
			}
			setLoadingClients(false);
		});
	};
	const submitWhoWeAre = () => {
		let data = {
			video: videoData?.video,
		};
		setVideoData((prev) => ({ ...prev, loading: true }));
		homeVideoService.create(data).then((res) => {
			if (res?.status === 201) {
				toast.success(`${Translate[lang].added_successfully}`);
				setShouldVideoUpdate((prev) => !prev);
				setVideoData({ video: "", loading: true });
			}
		});
	};

	const removeClient = (img) => {
		homeClientsService.remove(img?.id).then((res) => {
			if (res?.status === 200) {
				toast.success(
					`${Translate[lang].delete} ${Translate[lang].successfully}`
				);
				setClientsData((prev) => prev.filter((item) => item?.id !== img?.id));
			}
		});
	};

	const removeVidoe = () => {
		if (!videoData.uploaded) {
			setVideoData({ video: "", loading: false });
		} else {
			setVideoData((prev) => ({ ...prev, loading: true }));
			homeVideoService.remove().then((res) => {
				if (res?.status === 200) {
					toast.success(
						`${Translate[lang].delete} ${Translate[lang].successfully}`
					);
					setVideoData({ video: "", loading: false });
				}
			});
		}
	};

	return (
		<div>
			<AvForm className="form-horizontal mb-5" onValidSubmit={submitHeader}>
				<Row>
					<Col md={12} className="text-black fw-bold fs-24  mb-3">
						{Translate[lang].header}
					</Col>
					{/* Title En */}
					<Col md={6} className="mb-3">
						<label className={errors.english_title ? "text-danger" : ""}>
							{Translate[lang]?.english_title}
							<span className="star-require">*</span>
						</label>
						<Editor
							editorState={formData?.title_en}
							toolbarClassName="toolbarClassName"
							wrapperClassName="wrapperClassName"
							editorClassName="editorClassName"
							onEditorStateChange={(e) => {
								setFormData((prev) => ({ ...prev, title_en: e }));
								setErrors((prev) => ({ ...prev, title_en: false }));
							}}
						/>
						{errors.title_en && (
							<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
								{Translate[lang].field_required}
							</p>
						)}
					</Col>
					{/* Title Ar */}
					<Col md={6} className="mb-3">
						<label className={errors.title_ar ? "text-danger" : ""}>
							{Translate[lang]?.arabic_title}
							<span className="star-require">*</span>
						</label>
						<Editor
							editorState={formData?.title_ar}
							toolbarClassName="toolbarClassName"
							wrapperClassName="wrapperClassName"
							editorClassName="editorClassName"
							onEditorStateChange={(e) => {
								setFormData((prev) => ({ ...prev, title_ar: e }));
								setErrors((prev) => ({ ...prev, title_ar: false }));
							}}
						/>
						{errors.title_ar && (
							<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
								{Translate[lang].field_required}
							</p>
						)}
					</Col>
					{/* Description En */}
					<Col md={6} className="mb-3">
						<label className={errors.description_en ? "text-danger" : ""}>
							{Translate[lang]?.english_description}
							<span className="star-require">*</span>
						</label>
						<Editor
							editorState={formData?.description_en}
							toolbarClassName="toolbarClassName"
							wrapperClassName="wrapperClassName"
							editorClassName="editorClassName"
							onEditorStateChange={(e) => {
								setFormData((prev) => ({ ...prev, description_en: e }));
								setErrors((prev) => ({ ...prev, description_en: false }));
							}}
						/>
						{errors.description_en && (
							<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
								{Translate[lang].field_required}
							</p>
						)}
					</Col>
					{/* Description Ar */}
					<Col md={6} className="mb-3">
						<label className={errors.description_ar ? "text-danger" : ""}>
							{Translate[lang]?.arabic_description}
							<span className="star-require">*</span>
						</label>
						<Editor
							editorState={formData?.description_ar}
							toolbarClassName="toolbarClassName"
							wrapperClassName="wrapperClassName"
							editorClassName="editorClassName"
							onEditorStateChange={(e) => {
								setFormData((prev) => ({ ...prev, description_ar: e }));
								setErrors((prev) => ({ ...prev, description_ar: false }));
							}}
						/>
						{errors.description_ar && (
							<p className="text-danger m-0" style={{ fontSize: "12.8px" }}>
								{Translate[lang].field_required}
							</p>
						)}
					</Col>
					{/* Link */}
					<Col md={6}>
						<label>{Translate[lang]?.link}</label>
						<Select
							value={formData.link}
							name="link"
							placeholder={Translate[lang]?.select}
							options={LinksOptions}
							onChange={(e) =>
								setFormData({
									...formData,
									link: e,
								})
							}
						/>
					</Col>
					<Col md={6}></Col>
					<Col md={6} className="mt-3">
						<Button
							type="submit"
							disabled={submitHeaderLoader}
							variant="primary">
							{Translate[lang].submit}
						</Button>
					</Col>
				</Row>
			</AvForm>
			<AvForm className="form-horizontal mb-5" onValidSubmit={submitProjects}>
				<Row>
					<Col md={12} className="text-black fs-24 fw-bold mb-3">
						{Translate[lang].projects}
					</Col>
					{/* Projects */}
					<Col md={3}>
						<AvField
							label={Translate[lang]?.projects}
							type="number"
							placeholder={Translate[lang]?.projects}
							bsSize="lg"
							name="projects"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={projectData.projects}
							onChange={(e) =>
								setProjectData({
									...projectData,
									projects: e.target.value,
								})
							}
						/>
					</Col>
					{/* Employees */}
					<Col md={3}>
						<AvField
							label={Translate[lang]?.employees}
							type="number"
							placeholder={Translate[lang]?.employees}
							bsSize="lg"
							name="employeess"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={projectData.employees}
							onChange={(e) =>
								setProjectData({
									...projectData,
									employees: e.target.value,
								})
							}
						/>
					</Col>
					{/* Countries */}
					<Col md={3}>
						<AvField
							label={Translate[lang]?.countries}
							type="number"
							placeholder={Translate[lang]?.countries}
							bsSize="lg"
							name="countries"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={projectData.countries}
							onChange={(e) =>
								setProjectData({
									...projectData,
									countries: e.target.value,
								})
							}
						/>
					</Col>
					{/* Continents */}
					<Col md={3}>
						<AvField
							label={Translate[lang]?.continents}
							type="number"
							placeholder={Translate[lang]?.continents}
							bsSize="lg"
							name="continents"
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							value={projectData.continents}
							onChange={(e) =>
								setProjectData({
									...projectData,
									continents: e.target.value,
								})
							}
						/>
					</Col>
					<Col md={6}>
						<label className="text-label mb-0">{Translate[lang].images}</label>
						<div className="upload">
							<input
								type="file"
								name="image"
								id="image"
								accept="image/*"
								multiple
								onChange={(e) => fileHandler(e, "projects")}
							/>
							<p>{Translate[lang].upload_image}</p>
							{!projectData?.images?.length ? (
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M12 15V3.62"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M15.35 5.85L12 2.5L8.65002 5.85"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							) : (
								<svg
									width="24"
									height="24"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
										fill="#21AA37"
									/>
								</svg>
							)}
						</div>
						{!!projectData?.images?.length && (
							<div className="mt-4 d-flex gap-12">
								{projectData?.images?.map((res, index) => (
									<div className="mt-3 d-flex position-relative flex-column">
										<i
											className="las la-trash text-danger fs-20 cursor-pointer"
											onClick={() =>
												setProjectData((prev) => ({
													...prev,
													images: prev?.images?.filter(
														(_, ind) => ind !== index
													),
												}))
											}
										/>
										<img
											src={res}
											alt={index}
											key={index}
											height={140}
											style={{ borderRadius: "8px" }}
											width={120}
										/>
									</div>
								))}
							</div>
						)}
					</Col>
					<Col md={6}></Col>
					<Col md={6} className="mt-3">
						<Button
							type="submit"
							disabled={submitProjectsLoader || projectData?.loading}
							variant="primary">
							{Translate[lang].submit}
						</Button>
					</Col>
				</Row>
			</AvForm>
			<AvForm className="form-horizontal mb-5" onValidSubmit={submitClients}>
				<Row>
					<Col md={12} className="text-black fs-24 fw-bold mb-3">
						{Translate[lang].clients}
					</Col>
					<Col md={12}>
						<label className="text-label mb-0">{Translate[lang].images}</label>
						<div className="upload w-50">
							<input
								type="file"
								name="image"
								id="image"
								accept="image/*"
								multiple
								onChange={(e) => fileHandler(e, "clients")}
							/>
							<p>{Translate[lang].upload_image} / 200*150</p>
							{!clientsData?.length ? (
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M12 15V3.62"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M15.35 5.85L12 2.5L8.65002 5.85"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							) : (
								<svg
									width="24"
									height="24"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
										fill="#21AA37"
									/>
								</svg>
							)}
						</div>
						{(!!clientsData?.length || !!newClients?.length) && (
							<div
								style={{
									display: "grid",
									gridTemplateColumns: "auto auto auto auto auto",
									gap: "12px",
								}}
								className="mt-4">
								{clientsData?.map((res, index) => (
									<div
										style={{
											border: "1px solid #dedede",
											borderRadius: "10px",
										}}
										className="position-relative mt-3 d-flex flex-column">
										<i
											className="las la-trash text-danger fs-20 cursor-pointer"
											onClick={() => removeClient(res)}
										/>
										<img
											src={res?.image}
											alt={index}
											key={index}
											height={150}
											style={{ borderRadius: "8px" }}
											width={200}
										/>
									</div>
								))}
								{newClients?.map((res, index) => (
									<div
										style={{
											border: "1px solid #dedede",
											borderRadius: "10px",
										}}
										className="position-relative mt-3 d-flex flex-column">
										<i
											className="las la-trash text-danger fs-20 cursor-pointer"
											onClick={() =>
												setNewClients((prev) =>
													prev.filter((_, ind) => ind !== index)
												)
											}
										/>
										<img
											src={res?.image}
											alt={index}
											key={index}
											height={140}
											style={{ borderRadius: "8px" }}
											width={120}
										/>
									</div>
								))}
							</div>
						)}
					</Col>
					<Col md={12} className="mt-3">
						<Button type="submit" disabled={loadingClients} variant="primary">
							{Translate[lang].submit}
						</Button>
					</Col>
				</Row>
			</AvForm>
			<AvForm className="form-horizontal mb-5" onValidSubmit={submitWhoWeAre}>
				<Row>
					<Col md={12} className="text-black fs-24 fw-bold mb-3">
						{Translate[lang].who_we_are}
					</Col>
					<Col md={6}>
						<label className="text-label mb-0">{Translate[lang].video}</label>
						<div className="upload">
							<input
								type="file"
								name="video"
								accept="video/*"
								multiple
								onChange={(e) => fileHandler(e, "video")}
							/>
							<p>{Translate[lang].upload_video}</p>
							{!videoData?.video ? (
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M12 15V3.62"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M15.35 5.85L12 2.5L8.65002 5.85"
										stroke="#0F50A6"
										strokeWidth="1.5"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							) : (
								<svg
									width="24"
									height="24"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
										fill="#21AA37"
									/>
								</svg>
							)}
						</div>
						{!!videoData?.video && (
							<div className="mt-5 d-flex flex-column position-relative">
								<i
									className="las la-trash text-danger fs-20 cursor-pointer"
									onClick={() => removeVidoe()}
								/>
								<video width="320" height="240" controls>
									<source src={videoData?.video} type="video/mp4" />
									<source src={videoData?.video} type="video/ogg" />
								</video>
							</div>
						)}
					</Col>
					<Col md={12} className="mt-3">
						<Button
							type="submit"
							disabled={videoData?.loading}
							variant="primary">
							{Translate[lang].submit}
						</Button>
					</Col>
				</Row>
			</AvForm>
		</div>
	);
};
export default Home;
